import { SearchField } from '@routly/ui';

/**
 * The shared search field, with the console's English.
 *
 * This used to be its own copy of the markup, made before the product's version
 * gained a clear button and the two accessibility fixes, and it never caught up.
 */

interface SearchInputProps {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function SearchInput({ placeholder, value, onChange, className }: SearchInputProps) {
  return (
    <SearchField
      placeholder={placeholder}
      value={value}
      onValueChange={onChange}
      clearLabel="Clear search"
      containerClassName={className ?? 'flex-1 max-w-sm'}
    />
  );
}
